import React, { useState } from 'react';
import { useParams, useLocation } from 'react-router';
import {
  Container,
  FilterKey,
  FiltersCollection,
  updateFilterKeyOrder,
} from 'Book/shared';

import { List, Practitioner } from './components';

export default () => {
  const { state: locationState } = useLocation<{
    source?: string;
  }>();
  const params = useParams<{ practitionerId: string }>();
  const { practitionerId } = params;
  const [selectedFilters, setSelectedFilters] = useState<FiltersCollection>({
    languages: [],
    areasOfExpertise: [],
    approaches: [],
    genders: [],
    ethnicities: [],
  });

  const [filterKeyOrder, setFilterKeyOrder] = useState<FilterKey[]>([]);

  const onFilterChange = (newFilters: FiltersCollection) => {
    setFilterKeyOrder(order =>
      updateFilterKeyOrder(order, selectedFilters, newFilters),
    );
    setSelectedFilters(newFilters);
  };

  const onRemoveFilter = (key: FilterKey) => {
    onFilterChange({ ...selectedFilters, [key]: [] });
  };

  return (
    <Container>
      {!practitionerId ? (
        <List
          onFilterChange={onFilterChange}
          selectedFilters={selectedFilters}
          lastAddedFilterKey={filterKeyOrder[filterKeyOrder.length - 1]}
          onRemoveFilter={onRemoveFilter}
        />
      ) : (
        <Practitioner source={locationState?.source} />
      )}
    </Container>
  );
};
